/** @jsxImportSource @emotion/react */
import React from 'react';
import {useForm, Controller} from 'react-hook-form';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogFooter,
} from 'app/gakki/components/Dialog';
import Button, {ButtonGroup} from 'components/Button';
import {
  DatePicker,
} from 'components/form-items';
import {DateTime} from 'luxon';

const Form = (props: any) => {
  const {onClose, onSubmit, defaultValues} = props;
  const {
    control,
    handleSubmit,
    trigger,
    formState,
    errors,
    register,
  } = useForm({
    defaultValues,
  });
  const transferDateObj = (d: any) => (d ? new Date(d) : undefined);
  return (
    <Dialog isOpen css={{width: '500px', maxWidth: '500px'}} aria-label="salary-period-dialog">
      <DialogTitle
        onClose={onClose}
        title={'編輯計薪週期'}
      />
      <DialogContent css={{flexDirection: 'column', padding: '19.5px 0', fontSize: '14px' }}>
        <div css={{ height: '65px', marginBottom: '20px' }}>
          <label css={{ marginBottom: '10px', fontWeight: 600 }}>年度/月份</label>
          <div css={{ height: '35px', marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
            <input name='year' ref={register} hidden/>
            <input name='month' ref={register} hidden/>
            {`${defaultValues.year}/${defaultValues.month}`}
          </div>
        </div>
        <div css={{ height: '65px', marginBottom: '20px' }}>
          <label css={{ marginBottom: '10px', fontWeight: 600 }}>計薪週期(起)</label>
          <div css={{ height: '35px', marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
            <input name='salaryStart' ref={register} hidden/>
            {defaultValues.salaryStart}
          </div>
        </div>
        <div css={{ height: '65px', marginBottom: '20px' }}>
          <label css={{ marginBottom: '10px', fontWeight: 600 }}>計薪週期(迄)</label>
          <div css={{ height: '35px', marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
            <input name='salaryEnd' ref={register} hidden/>
            {defaultValues.salaryEnd}
          </div>
        </div>
        <div css={{ height: '65px', marginBottom: '20px' }}>
          <label css={{ marginBottom: '10px', fontWeight: 600 }}>發薪日</label>
          <div css={{ height: '35px', display: 'flex', flexDirection: 'column' }}>
            <Controller
              render={({onChange, value}) => (
                <DatePicker
                  id={`salaryDay`}
                  dateFormat="yyyy/MM/dd"
                  selected={transferDateObj(value)}
                  onChange={async (date: Date) => {
                    onChange(date
                        ? DateTime.fromJSDate(date).toLocaleString()
                        : null,
                    );
                    trigger();
                  }}
                  error={formState.isSubmitted && errors?.salaryDay}
                />
              )}
              name={`salaryDay`}
              control={control}
              rules={{ required: true }}
              defaultValue={defaultValues.salaryDay}
            />
          </div>
        </div>
      </DialogContent>
      <DialogFooter>
        <ButtonGroup>
          <Button variant={'primary'} onClick={onClose} className={'close-btn'}>
            取消
          </Button>
          <Button
            variant={'cta'}
            onClick={handleSubmit(onSubmit)}
            className={'confirm-btn'}
          >
            確定
          </Button>
        </ButtonGroup>
      </DialogFooter>
    </Dialog>
  );
};

export default Form;
